/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationid200,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationid401,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationid404,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationid500,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidPathParams,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidQueryResponse,
} from "../../types/courseRegistrationDocumentApprovalController/GetApiV1CourseregistrationDocumentApprovalCourseregistrationid.ts";
import { personDocumentApprovalViewerViewModelSchema } from "../personDocumentApprovalViewerViewModelSchema.ts";

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationid200Schema =
  z.lazy(
    () => personDocumentApprovalViewerViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationid401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationid404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationid500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationid500>;

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationDocumentApprovalCourseregistrationid200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidQueryResponse>;
